import React from 'react';
import clsx from 'clsx';
import { ReactComponent as ArrowIcon } from 'images/arrow-next.svg';
import { ReactComponent as CheckIcon } from 'images/green-check-rounded.svg';
import { useNavigate } from 'hooks/useNavigate';
import { RoutePath } from 'enums/Routes';
import { StepId, StepProgress, StepsHook } from 'components/Steps/stepUtils';

import styles from './ReturningFlow.module.scss';

export const ReturningFlow = <Id extends StepId, Progress extends StepProgress>(
  useStepsHook: StepsHook<Id, Progress>,
  stepsRoute: RoutePath,
) => {
  const { stepsProgress, stepData, firstIncompleteStepIndex } = useStepsHook();
  const navigate = useNavigate();

  const handleContinue = (stepId: Id, isInitialStep: boolean, isNextUncompletedStep: boolean) => {
    if (!stepsProgress[stepId] && !isInitialStep && !isNextUncompletedStep) return;
    navigate(stepsRoute, {
      state: {
        step: stepId,
      },
    });
  };

  return (
    <div className={styles.container}>
      {stepData.map((step, index) => {
        const isInitialStep = stepData[0].id === step.id;
        const isNextUncompletedStep = firstIncompleteStepIndex === index;

        const activateStep = stepsProgress[step.id] || isInitialStep || isNextUncompletedStep;

        return (
          <div
            key={step.id}
            className={clsx(styles.step, { [styles.stepSelectable]: activateStep })}
            onClick={() => handleContinue(step.id, isInitialStep, isNextUncompletedStep)}
          >
            {stepsProgress[step.id] ? <CheckIcon className={styles.icon} /> : <step.icon className={styles.icon} />}
            <div className={styles.name}>{step.name}</div>
            {activateStep && <ArrowIcon className={styles.arrowIcon} />}
          </div>
        );
      })}
    </div>
  );
};

export default ReturningFlow;
